import { render, staticRenderFns } from "./LoadTypeView.vue?vue&type=template&id=6fce4ce1&"
import script from "./LoadTypeView.vue?vue&type=script&lang=js&"
export * from "./LoadTypeView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports